<template>
  <div>
    <div class="loading" v-if="!userInfo">
      <div class="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-if="userInfo">
      <!-- notify-->
      <div
        class="d-flex align-items-center"
        id="idc-notify-account"
        v-if="userInfo.has_expired_invoices"
      >
        <div class="mr-1 d-flex align-items-center">
          <i class="idc-icons loudspeaker"></i>
          <p class="my-0 ml-1">{{$t('notify.hasExpiredInvoices')}}</p>
        </div>
      </div>
      <!--div
        class="d-flex align-items-center"
        id="idc-notify-account"
        v-if="userInfo.trial && !userInfo.created_resources && !userInfo.trial.active && !userInfo.trial.start_date && showNotifyFreeTrial"
      >
        <div class="mr-1 d-flex align-items-center">
          <i class="idc-icons loudspeaker"></i>
          <p class="my-0 ml-1">{{$t('notify.freeTrialExperience')}}</p>
        </div>
        <div class="ml-auto d-flex align-items-center">
          <el-button
            plain
            size="mini"
            class="ml-auto"
            @click="gotoTicket()"
          >{{$t('auth.register.btn')}}</el-button>
          <i class="el-icon-close text-white hover ml-1" @click="closeNotifyFreeTrial()"></i>
        </div>
      </div-->
      <div
        class="d-flex align-items-center"
        id="idc-notify-account"
        v-if="userInfo.trial && userInfo.trial.active && userInfo.trial.start_date && userInfo.trial.expired"
      >
        <div class="mr-1 d-flex align-items-center">
          <i class="idc-icons loudspeaker"></i>
          <p class="my-0 ml-1">{{$t('notify.trialExpires')}}</p>
        </div>
        <a
          type="primary"
          class="ml-auto text-decoration"
          @click="openModalUpgradeAccount"
        >Thanh toán</a>
      </div>
      <div
        class="d-flex align-items-center"
        id="idc-notify-account"
        v-if="userInfo.trial && userInfo.trial.active && userInfo.trial.start_date && !userInfo.trial.expired"
      >
        <div class="mr-1 d-flex align-items-center">
          <i class="idc-icons loudspeaker"></i>
          <p
            class="my-0 ml-1"
          >{{$t('notify.inTrialTxt1')}} {{userInfo.trial.end_date | filterTimezone | moment("HH:mm DD-MM-YYYY")}}, {{$t('notify.inTrialTxt2')}}</p>
        </div>
        <a
          type="primary"
          class="ml-auto text-decoration"
          @click="openModalUpgradeAccount"
        >Thanh toán</a>
      </div>
      <!--/ notify-->
      <sidebar
        :currentPage="currentPage"
        :isHasNotify="isHasNotify"
        :isCollapse="isCollapse"
        @switchCollapse="switchCollapse"
      ></sidebar>
      <div id="idc-container-right">
        <header-menu
          :userInfo="userInfo"
          :isHasNotify="isHasNotify"
          :currentPage="currentPage"
          :isCollapse="isCollapse"
          @setLocale="handleSetLocale"
          @switchCollapse="switchCollapse"
        ></header-menu>
        <div class="app-main py-2 px-1" :class="'local-' + locale">
          <router-view :isHasNotify="isHasNotify" :key="key" />
        </div>
      </div>
      <footer>
        <span>IDC Online Cloud Portal</span>
        <span>Hotline: 19006452</span>
        <span>Email: support@idconline.vn</span>
      </footer>
      <!-- MODAL UPGRADE ACCOUNT-->
      <modal-upgrade-account
        :userInfo="userInfo"
        :isOpenModalUpgradeAccount="isOpenModalUpgradeAccount"
        @closeModalUpgradeAccount="closeModalUpgradeAccount"
        @upgradeAccount="handleUpgradeAccount"
      ></modal-upgrade-account>
      <!--/ MODAL UPGRADE ACCOUNT-->
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import Sidebar from './components/sidebar'
  import HeaderMenu from './components/header'
  import ModalUpgradeAccount from './components/upgrade-account'
  import authService from '@/services/auth'
  export default {
    props: ['currentPage'],
    components: {
      Sidebar,
      HeaderMenu,
      ModalUpgradeAccount
    },
    data () {
      return {
        isOpenModalUpgradeAccount: false,
        isFetchingCpuBilling: true,
        isFetchingRamBilling: true,
        isFetchingDiskHddBilling: true,
        isFetchingDiskSsdBilling: true,
        isFetchingSnapshotHddBilling: true,
        isFetchingSnapshotSsdBilling: true,
        isHasNotify: false,
        showNotifyFreeTrial: false,
        priceDiskHdd: {},
        priceDiskSsd: {},
        priceSnapshotHdd: {},
        priceSnapshotSsd: {},
        priceCpu: {},
        priceRam: {},
        isCollapse: false,
        locale: localStorage.locale,
        routerActions: ['cloud-server.create', 'volume.create', 'snapshot.create']
      }
    },
    computed: {
      ...mapGetters([
        'userInfo'
      ]),
      key () {
        return this.$route.path
      }
    },
    watch: {
      'userInfo' (value) {
        if (value) {
          // check is has notify
          this.checkIsHasNotify()
        }
      },
      'isCollapse' (value) {
        if (!value) {
          document.getElementById('idc-container-right').style.paddingLeft = '200px'
        } else {
          setTimeout(() => {
            document.getElementById('idc-container-right').style.paddingLeft = '72px'
          }, 300)
        }
      }
    },
    methods: {
      handleSetLocale (locale) {
        this.$emit('setLocale', locale)
        localStorage.locale = locale
        this.locale = _.cloneDeep(locale)
      },
      checkIsHasNotify () {
        // check email ignore free trial subscription
        let ignoreFreeTrial = this.userInfo ? localStorage.getItem(`ignoreFreeTrial_${this.userInfo.email}`) : null
        if (!ignoreFreeTrial) {
          localStorage.setItem('showNotifyFreeTrial', false)
          this.showNotifyFreeTrial = false
        } else {
          localStorage.setItem('showNotifyFreeTrial', false)
          this.showNotifyFreeTrial = false
        }
        // has expired invoices
        const userHasExpiredInvoices = this.userInfo && this.userInfo.has_expired_invoices
        // free trial subscription
        const freeTrialSubscription = (this.userInfo && this.userInfo.trial && this.userInfo.trial.active && this.userInfo.trial.start_date && !this.userInfo.trial.expired)
        // in free trial period
        const inFreeTrial = (this.userInfo && this.userInfo.trial && this.userInfo.trial.active && this.userInfo.trial.start_date && this.userInfo.trial.expired)
        this.isHasNotify = !!(userHasExpiredInvoices || inFreeTrial || freeTrialSubscription)
      },
      closeNotifyFreeTrial () {
        if (this.userInfo) {
          localStorage.setItem('showNotifyFreeTrial', false)
          localStorage.setItem(`ignoreFreeTrial_${this.userInfo.email}`, true)
          this.showNotifyFreeTrial = false
        }
        this.checkIsHasNotify()
      },
      gotoTicket () {
        if (this.$router.history.current.name !== 'ticket.index') {
          this.$router.push({
            name: 'ticket.index',
            query: {subject: 'Tôi muốn dùng thử dịch vụ'}
          })
        }
      },
      openModalUpgradeAccount () {
        authService.check()
          .then(() => {
            this.isOpenModalUpgradeAccount = true
          })
      },
      closeModalUpgradeAccount () {
        this.isOpenModalUpgradeAccount = false
      },
      handleUpgradeAccount (showNotify) {
        if (showNotify === 'hideNotify') this.isHasNotify = false
      },
      switchCollapse () {
        this.isCollapse = !this.isCollapse
      },
      checkWidthWindows () {
        const width = window.innerWidth
        if (width <= 1024) this.isCollapse = true
      }
    },
    mounted () {
      this.checkWidthWindows()
      this.checkIsHasNotify()
      window.addEventListener('mouseup', function (event) {
        var sidebar = document.getElementById('idc-sidebar')
        if (event.target !== sidebar && event.target.parentNode !== sidebar) {
          sidebar.classList.remove('show')
        }
      })
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/idc/index.vue